
import { Plug, MessageSquare, Zap } from 'lucide-react';

const HowItWorks = () => {
  return (
    <section className="container mx-auto px-4 py-8 relative z-10">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-800 mb-3">
          How It Works
        </h2>
        <p className="text-md text-slate-600">
          Three simple steps to transform your business operations
        </p>
      </div>
      
      <div className="bg-gradient-to-r from-blue-50/80 via-white/90 to-indigo-50/80 backdrop-blur-sm rounded-3xl p-8 mx-4 mb-6 border border-blue-100 shadow-xl hover:shadow-2xl transition-all duration-500">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center group">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-full flex items-center justify-center text-sm font-bold mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300 group-hover:shadow-xl">
                1
              </div>
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Plug className="h-10 w-10 text-blue-600" />
              </div>
              <h3 className="text-md font-semibold text-slate-800 mb-2">Plug In Once</h3>
              <p className="text-slate-600 text-sm mb-3 font-medium">
                One-time setup.<br />No new software to learn.
              </p>
              <p className="text-xs text-slate-500">
                Connect your tools — QuickBooks, Square, your POS, calendar, and more. One setup. Done.
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-full flex items-center justify-center text-sm font-bold mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300 group-hover:shadow-xl">
                2
              </div>
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <MessageSquare className="h-10 w-10 text-blue-600" />
              </div>
              <h3 className="text-md font-semibold text-slate-800 mb-2">Tell Carto What Matters</h3>
              <p className="text-slate-600 text-sm mb-3 font-medium">
                You lead.<br />Carto adapts.
              </p>
              <p className="text-xs text-slate-500">
                Every business has different goals. Carto adapts to yours.
              </p>
            </div>
            
            <div className="text-center group">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-indigo-600 text-white rounded-full flex items-center justify-center text-sm font-bold mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300 group-hover:shadow-xl">
                3
              </div>
              <div className="w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full flex items-center justify-center mx-auto mb-3 shadow-lg group-hover:scale-110 transition-transform duration-300">
                <Zap className="h-10 w-10 text-blue-600" />
              </div>
              <h3 className="text-md font-semibold text-slate-800 mb-2">Let Carto Get To Work</h3>
              <p className="text-slate-600 text-sm mb-3 font-medium">
                More clarity. More time.<br />More progress.
              </p>
              <p className="text-xs text-slate-500">
                Carto checks your numbers, surfaces opportunities, handles admin and sends back the progress — all via text.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
